// 存储用户信息至session
export function setSession(name, value) {
    window.sessionStorage.setItem(name, value);
}
// 获取用户信息
export function getSession(name) {
    return window.sessionStorage.getItem(name);
}
// 清除用户信息
export function clearSession(name) {
    window.sessionStorage.removeItem(name)
}
// 存放账号密码至cookie
export function setCookie(c_name, c_pwd, exdays) {
    var exdate = new Date(); //获取时间
    exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
    //字符串拼接cookie
    let platformUserInfo = {
        platUserName: c_name,
        platUserPwd: c_pwd
    }
    window.document.cookie = "platformUserInfo" + "=" + JSON.stringify(platformUserInfo) + ";path=/;expires=" + exdate.toGMTString();
}
// 清除cookie
export function clearCookie() {
    setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
}
// 获取cookie
export function getCookie(c_name) {
    //判断document.cookie对象里面是否存有cookie
    if (document.cookie.length > 0) {
        let c_start = document.cookie.indexOf(c_name + "=")
        //如果document.cookie对象里面有cookie则查找是否有指定的cookie，如果有则返回指定的cookie值，如果没有则返回空字符串
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1
            let c_end = document.cookie.indexOf(";", c_start)
            if (c_end == -1) c_end = document.cookie.length
            return unescape(document.cookie.substring(c_start, c_end))
        }
    }
    return ""
}